import { render, staticRenderFns } from "./Flow.vue?vue&type=template&id=236488ee&scoped=true&lang=html&"
import script from "./Flow.vue?vue&type=script&lang=coffee&"
export * from "./Flow.vue?vue&type=script&lang=coffee&"
import style0 from "./Flow.vue?vue&type=style&index=0&id=236488ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "236488ee",
  null
  
)

component.options.__file = "Flow.vue"
export default component.exports